
import { getProps } from '../props'
import create from '../Services/create'
import update from '../Services/update'

export default async (values, dispatch) => {
console.log("S VAL",values);
  const { onClose, didCreate, didUpdate } = getProps()

  if (!values.setting_value_id) {

    const setting = await dispatch(create(values))

    onClose()

    if (didCreate) didCreate(setting)

  } else {

    const setting = await dispatch(update(values))

    onClose()

    if (didUpdate) didUpdate(setting)

  }

}
